import WhatsAppWidget from "react-whatsapp-chat-widget";
import "react-whatsapp-chat-widget/index.css";

const LiveWhatsapp = () => {
	return (
		<WhatsAppWidget
			phoneNo="+2348126684339"
			position="right"
			widgetWidth="300px"
			widgetWidthMobile="260px"
			autoOpen={false}
			autoOpenTimer={3000}
			messageBox={true}
			messageBoxTxt=""
			iconSize="40"
			iconColor="white"
			iconBgColor="#EC3337"
			headerIcon="https://scontent.flos3-1.fna.fbcdn.net/v/t39.30808-6/242003295_217230243777432_2293183564311489268_n.png?_nc_cat=100&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeEQxbX7ArouTYk_XWe245yAOWodlVt0tiU5ah2VW3S2JfmFmRU0udp25wSJVY6lOljRv0p5ky1cqEep2PNMyYDs&_nc_ohc=4tNIEehW34gAX88RY-7&_nc_zt=23&_nc_ht=scontent.flos3-1.fna&oh=00_AfBetgNYYXB5QNaLEzJhINh7iUGLhEbLRPubPzd2On5SDA&oe=63BB7464"
			headerIconColor="pink"
			headerTxtColor="black"
			headerBgColor="#EC3337"
			headerTitle="Muili Bolaji"
			headerCaption="Online"
			bodyBgColor="#F9F8F8"
			chatPersonName="Support"
			chatMessage={<>Hi there 👋 <br /><br /> How can I help you?</>}
			footerBgColor="#F9F8F8"
			btnBgColor="#EC3337"
			btnTxtColor="black"
			btnTxt="Start Chat"
		/>
	);
};

export default LiveWhatsapp;